<template>
  <div class="basic-block block-review-base" :style="styles">
    <img v-if="targetInfo.review.deco" :src="targetInfo.review.deco" class="block-review-base__deco" alt="">
    <div class="content-wrap">
      <div class="block-review-base__inner">
        <lp-title title="お客様からの声" :color-scheme="colorScheme" alphabet="reviews" />
        <ul class="block-review-base__list">
          <li v-for="(item, idx) of reviewList" :key="idx">
            <img :src="item.icon" alt="">
            <p>{{ item.review }}</p>
          </li>
        </ul>
        <div class="btn-wrap">
          <div class="mess">今話題の宇宙占術ＲＰＵで<br>あなたの本当の能力を<br>見つけてみませんか？</div>
          <lp-base-button
            :label="label"
            design="fill"
            :color-scheme="colorScheme"
            @clicked="onBtnClick"
            class="btn-free-shindan"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LpTitle from '@/utvStore/components/recommend/lp/partials/LpTitle'
import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton'

export default {
  name: 'BlockReview',
  components: {
    LpTitle,
    LpBaseButton,
  },
  props: {
    lpId: {
      type: Number,
      default: 1,
    },
    targetInfo: {
      type: Object,
      default(){
        return {}
      }
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    reviewList: {
      type: Array,
      default(){
        return []
      }
    },
    deco: String,
    page: {
      type: String,
      default: '',
    },
    subscUrl: String,
  },
  data() {
    return {
      label: '<span>▶︎</span>無料で占う',
    }
  },
  computed:{
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    }
  },
  created() {
    if (this.page == 'basicresult') {
      this.label = '<span>▶︎</span>占い放題に登録'
    }
  },
  methods: {
    onBtnClick() {
      if (this.page == 'basicresult') {
        window.gtag('event', 'click', {
          'event_category': `LP${this.lpId}${this.page}-subsc-button`,
          'event_label': 'point6',
        })
        location.href = this.$handoverParams(this.subscUrl)
      } else {
        window.gtag('event', 'click', {
          'event_category': `LP${this.lpId}-free-shindan-button`,
          'event_label': 'bottom',
        })
        location.href = this.$handoverParams(`/recommend/lp/${this.lpId}/basic/input`)
      }
    },
  },
}</script>

<style scoped lang="scss">
@import "../../../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

.block-review-base {
  padding: 60px 0 60px;
  background: #fff;
  &__deco {
    position: absolute;
    top: -46px;
    left: 0;
    width: 17.6%;
    max-width: 80px;
    z-index: 2;
  }
  &__inner {
    padding: 0 20px;
    @include mq('w580') {
      padding: 0 40px;
    }
    .btn-wrap {
      padding: 0 16px;
      .mess {
        font-size: 20px;
        font-weight: bold;
        line-height: 28px;
        text-align: center;
        color: $l_col_keycolor;
        margin-bottom: 24px;
        @include mq('w580'){
          font-size: 26px;
          line-height: 38px;
          margin-bottom: 40px;
        }
      }
      .btn-free-shindan {
        max-width: 372px;
        margin: 0 auto;
        /deep/ {
          .baseButton__button {
            filter: drop-shadow(0px 5px 15px rgba(0, 0, 0, 0.25));
            display: flex;
            justify-content: center;
            align-items: center;
            height: 60px;
            &__label {
              font-size: 22px;
              span {
                margin-right: 16px;
              }
            }
          }
        }
      }
    }
  }
  &__list {
    margin: 0 0 20px;
    padding: 4px 20px;
    list-style: none;
    background: #FFFFFF;
    border: 1px solid #DADADA;
    border-radius: 10px;
    @include mq('w580'){
      margin: 0 0 40px;
    }
    > li {
      padding: 16px 0 16px 2px;
      display: flex;
      align-items: center;
      + li {
        border-top: 1px solid #DADADA;
      }
      img {
        max-width: 55px;
        margin: 0 11px 0 0;
      }
      p {
        margin: 0;
        font-size: 12px;
        line-height: 18px;
        text-align: justify;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/ottimo/blocks/BlockReview.vue